
import { i18nText } from '@/locales';

import {Component, Prop, Vue} from "vue-property-decorator";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {TablesStore} from "@/store/modules/Tables";
import {ITableColumn} from "@/entity/table/table.types";
import {IPosition} from "@/entity/position/position.types";
import {IStatus} from "@/entity/status/status.types";
import {ICategory} from "@/entity/category/category.types";
import {ISalaryScheme} from "@/entity/salaryScheme/salaryScheme.types";
import {IServiceCosmetologists} from '@/entity/serviceCosmetologists/serviceCosmetologists.types';
import {SalaryStore} from "@/store/modules/Salary";
import {StatusesStore} from "@/store/modules/Status";
import {PositionStore} from "@/store/modules/Position";
import {CategoryStore} from "@/store/modules/Category";
import {WorkersStore} from "@/store/modules/Workers";
import {ServiceCosmetologistsStore} from "@/store/modules/ServiceCosmetologists";
import {IWorkers, IWorkersListItem} from "@/entity/workers/workers.types";
import WorkerAddForm from "@/form/workerAdd/workerAdd";
import {message} from "ant-design-vue";
import ServiceCreateForm from "@/form/serviceCreate/serviceCreate";
import {IServicesListItem} from "@/entity/services/services.types";
import {ServiceStore} from "@/store/modules/Services";
import ServiceGeneralForm from "@/form/serviceGeneral/serviceGeneral";
import {ICms_Category} from '@/entity/staff/staff.types'


@Component({
  components: {FormGroup, PageTitle}
})
export default class ServiceWorkers extends Vue {

  workerForm = new WorkerAddForm();

  form = new ServiceCreateForm();
  formService = new ServiceGeneralForm();

  @Prop() readonly service!: IServicesListItem;

  visible: boolean;
  currentStaff: Array<Record<any, any>> = [];
  worker: IWorkersListItem | null = null;

  constructor() {
    super();
    this.visible = false;
  }

  async getServiceStaff() {
    await ServiceCosmetologistsStore.fetchAll({filter: {'service_id': this.service.id}});
    this.currentStaff = [];

    if (this.service && this.serviceStaff && this.serviceStaff.data.length) {
      for (let i = 0; i < this.serviceStaff.data.length; i++) {
        this.currentStaff.push(this.serviceStaff.data[i]);

        /*if(this.staff && this.staff.data) {
          this.staff.data = this.staff.data.filter((element) => this.serviceStaff?.data[i].id !== element.id)
        }*/
      }
    }

    if (!this.currentStaff.length) {
      this.currentStaff.push({});
    }
  }

  addStaffLine() {
    this.currentStaff.push({});
  }

  async saveServicesStaff() {

    let data = {
      'id': null,
      'service_id': this.service.id,
      'cosmetologists_id': []
    };

    for (let i = 0; i < this.currentStaff.length; i++) {
      (data.cosmetologists_id as number[]).push(this.currentStaff[i].id);
    }

    const response = (await ServiceCosmetologistsStore.create(data));

    if (response && response.status) {
      await this.getServiceStaff();
      message.success(i18nText("Косметологи успешно добавлены"));
    } else {
      message.error(response.response)
    }

  }

  collectStaff(value: any, index: number) {
    if (this.staff?.data) {
      let item = this.staff.data.filter((e) => e.id === value);
      this.currentStaff[index] = item[0];
    }
  }

  showModal() {
    this.visible = true;
  }

  handleOk(e: any) {
    console.log(e);
    this.visible = false;
  }

  handleCancel(e: any) {
    this.visible = false;
  }

  get serviceWorkersColumns(): ITableColumn[] {
    return TablesStore.serviceDetailWorkersColumns;
  }

  get staff(): IWorkers | null {
    return WorkersStore.workers;
  }

  get serviceStaff(): IServiceCosmetologists | null {
    return ServiceCosmetologistsStore.serviceCosmetologist;
  }

  get positions(): IPosition[] {
    return PositionStore.position;
  }

  get statuses(): IStatus[] {
    return StatusesStore.status;
  }

  get categories(): ICms_Category[] {
    return CategoryStore.category;
  }

  get salary(): ISalaryScheme[] {
    return SalaryStore.salary;
  }

  async deleteWorker(id: number): Promise<void> {
    const response = (await ServiceCosmetologistsStore.delete({cosmetologist_id: id, service_id: this.service.id}));
    if (response.status) {
      await this.getServiceStaff();
      message.success(response.response)
    } else {
      message.error(response.response)
    }

  }

  async created(): Promise<void> {
    //     await WorkersStore.fetchAll({limit: 10});
    //     //await ServiceCosmetologistsStore.fetchAll();
    //     let res = WorkersStore.workers;
    //     console.log(res);
    //     await StatusesStore.fetchAll();
    //     await CategoryStore.fetchAll();
    //     await PositionStore.fetchAll();
    //     await SalaryStore.fetchAll();
    // this.workerForm.setFormDataWithoutId(this.positions, this.categories, this.statuses, this.salary);
    //await ServiceStore.fetchData({filter: {id: parseInt(this.$route.params.id)}});
    if (this.service) {
      await this.getServiceStaff();
      this.formService.setFormData(this.service);
    }
  }
}
